import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import {Backdrop} from "@mui/material";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import Radio from "@mui/material/Radio";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import React from "react";
import {useTranslation} from "react-i18next";
import {createNewServiceReceipt} from "../../services/requests/CreateNewReceipt";
import ReportDialog from "../admin_components/ReportDialog";
import CashPicker from "./CashPicker";

export default function NewServiceReceipt(props) {
	const {t} = useTranslation();
	const [organization, setOrganization] = React.useState({});
	const [openSuccess, setOpenSuccess] = React.useState(false);
	const [error, setError] = React.useState({
		status: false,
		msg: "Error",
		code: 0,
	});

	const [card, setCard] = React.useState({});
	// type 1 - input; 2 - output
	const [type, setType] = React.useState("");
	const [newReceipt, setNewReceipt] = React.useState(null);

	function handleChangeType(event) {
		setType(event.target.value);

		if (newReceipt) {
			setNewReceipt(null)
		}
	}

	const [summ, setSumm] = React.useState("");

	const handleChangePrice = (event) => {
		let price = event.target.value;
		let str = price.replace(".", "");
		let result = "";
		if (str.length <= 2) {
			let pad = "0.00";
			result = pad.substring(0, pad.length - str.length) + str;
		}
		if (str.length > 2) {
			let x_res =
				parseInt(str.substring(0, str.length - 2)).toString() +
				"." +
				str.substring(str.length - 2, str.length);
			result = x_res;
		}
		setSumm(result);

		if (newReceipt) {
			setNewReceipt(null)
		}

	};

	const onCashRegisterFormSubmit = (data) => {
		setOrganization(data.organization);
		setCard(data.formData);
	};

	const [showReceipt, setShowReceipt] = React.useState(false);
	const [isReceiptCreated, setIsReceiptCreated] = React.useState(false);

	function createReceipt() {
		const param = {
			soap_data: {
				card,
				data: {
					type: parseInt(type),
					name: "MDL",
					total: summ,
				},
			},
		};
		createNewServiceReceipt(param)
			.then((data) => {
				if (data.data.soap_data) {
					setOpenSuccess(true);
					setIsReceiptCreated(true);
					setNewReceipt(data.data);
				} else {
					setError({
						status: true,
						msg: "There are errors while receipt generation",
					});
				}
			})
			.catch((error) => {
				const data = error?.response?.data || {};
				const msg =
					data.error || "There are errors while receipt generation";
				setError({
					status: true,
					msg,
					code: error?.response?.status,
				});
			});
	}

	const [vererification, setVererification] = React.useState(false);

	React.useEffect(() => {
		if (card && card.address !== "" && type !== "" && summ !== "") {
			if (parseFloat(summ) > 0) {
				setVererification(true);
			} else {
				setVererification(false);
			}
		}

		setShowReceipt(false);
		setIsReceiptCreated(false);
	}, [card, type, summ]);

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setOpenSuccess(false);
		setError({
			status: false,
			msg: "Error",
		});
	};
	const isCashRegisterAvailable = !!Object.keys(card).length;
	const isSfsError = error.code === 450;
	const isZError = error.code === 460;

	return (
		<>
			{isZError && (
				<ReportDialog
					message={error.msg}
					setError={setError}
					card={card}
				/>
			)}
			{error.status && isSfsError ? (
				<Backdrop open={error.status} sx={{zIndex: 99999}}>
					<Box
						style={{
							display: "flex",
							width: 500,
							alignItems: "center",
							flexDirection: "column",
							justifyContent: "center",
							backgroundColor: "#fff",
							padding: 16,
							borderRadius: 5,
						}}
					>
						<WarningAmberIcon color="error" sx={{fontSize: 40}}/>
						<p>{`${error.msg}`}</p>
						<Button
							onClick={() => setError({status: false, msg: ""})}
						>
							{t("retry")}
						</Button>
					</Box>
				</Backdrop>
			) : error.status ? (
				<Snackbar
					open={error.status}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="error"
						sx={{width: "100%"}}
					>
						{error.msg}
					</Alert>
				</Snackbar>
			) : null}
			<Box
				sx={{
					flexGrow: 1,
					marginTop: 3,
					marginLeft: 10,
					marginBottom: 10,
				}}
			>
				<Grid container spacing={4} align="left">
					<Grid item xs={6}>
						<CashPicker onSubmit={onCashRegisterFormSubmit}/>
						{isCashRegisterAvailable && (
							<>
								<Grid container spacing={2} align="left">
									<Grid item xs={11}>
										<FormControlLabel
											value={t("cash_in")}
											control={
												<Radio
													checked={type === "1"}
													onChange={handleChangeType}
													value="1"
													name="radio-button-input"
													inputProps={{
														"aria-label": "input",
													}}
												/>
											}
											label={t("cash_in")}
										/>
										<FormControlLabel
											value={t("cash_collection")}
											control={
												<Radio
													checked={type === "2"}
													onChange={handleChangeType}
													value="2"
													name="radio-button-output"
													inputProps={{
														"aria-label": "output",
													}}
												/>
											}
											label={t("cash_collection")}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={2} align="left">
									<Grid item xs={12}>
										<FormControl
											fullWidth
											sx={{m: 1}}
											variant="standard"
										>
											<InputLabel htmlFor="component-simple">
												{t("sum")}
											</InputLabel>
											<Input
												id="component-simple-summ"
												sx={{align: "right"}}
												value={summ}
												onChange={(event) =>
													handleChangePrice(event)
												}
												name="summ"
											/>
										</FormControl>
									</Grid>
								</Grid>
								<Grid container spacing={2} align="left">
									<Grid item xs={6}>
										<Button
											variant="outlined"
											sx={{width: "100%"}}
											disabled={!vererification}
											onClick={() => {
												setShowReceipt(true);
											}}
										>
											{t("view")}
										</Button>
									</Grid>
									<Grid item xs={6}>
										<Button
											variant="outlined"
											sx={{width: "100%"}}
											disabled={
												!vererification ||
												!showReceipt ||
												isReceiptCreated
											}
											onClick={() => {
												createReceipt();
											}}
										>
											{t("generate_and_send")}
										</Button>
									</Grid>
								</Grid>
							</>
						)}
					</Grid>
					<Grid
						item
						xs={6}
						sx={{visibility: showReceipt ? "visible" : "hidden"}}
					>
						<Card sx={{width: 375}}>
							<CardContent>
								<Typography
									variant="h5"
									component="h5"
									color="text.secondary"
									align="center"
								>
									{organization.name}
								</Typography>
								<Typography
									sx={{fontSize: 14}}
									color="text.secondary"
									align="center"
									gutterBottom
								>
									COD FISCAL: {organization.idno}
								</Typography>
								<Typography
									sx={{fontSize: 14}}
									color="text.secondary"
									align="center"
									gutterBottom
								>
									{card.address}
								</Typography>
								{newReceipt?.activity_type ? <Typography
									sx={{fontSize: 14}}
									color="text.secondary"
									align="center"
									gutterBottom
								>
									{t(`activity_${newReceipt.activity_type}`)}
								</Typography> : null}
								<Divider/>
								<Grid container spacing={2}>
									<Grid item xs={7} align="left">
										<Typography
											sx={{
												fontSize: 14,
												fontWeight: 600,
											}}
											color="text.secondary"
											gutterBottom
										>
											{type === "1" && (
												<>Încasare numerar</>
											)}
											{type === "2" && (
												<>Extragere numerar</>
											)}
										</Typography>
									</Grid>
									<Grid item xs={5} align="right">
										<Typography
											sx={{
												fontSize: 14,
												fontWeight: 600,
												wordBreak: "break-all",
												textAlign: "right",
											}}
											color="text.secondary"
											gutterBottom
										>
											{summ}
										</Typography>
									</Grid>
								</Grid>
								<Divider/>
								<Grid container spacing={2} align="left">
									<Grid item xs={8}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											NUMARUL DE IDENTIFICARE
										</Typography>
									</Grid>
									<Grid item xs={4} align="right">
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											{newReceipt?.soap_data?.id}
										</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={2} align="left">
									<Grid item xs={8}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											Casier:
										</Typography>
									</Grid>
									<Grid item xs={4} align="right">
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											{newReceipt?.user?.login || '-'}
										</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={2} align="left">
									<Grid item xs={8}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											BON DE SERVICIU
										</Typography>
									</Grid>
									<Grid item xs={4} align="right">
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											{newReceipt?.soap_data?.receipt}
										</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={2} align="left">
									<Grid item xs={8}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											DATA: <CurrentDate/>
										</Typography>
									</Grid>
									<Grid item xs={4} align="right">
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											ORA: <CurrentTime/>
										</Typography>
									</Grid>
								</Grid>
								{newReceipt && (
									<Grid container spacing={2} align="left">
										<Grid item xs={8}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
											>
												DATA MEV:{" "}
												{
													newReceipt?.soap_response?.datetime?.split(
														"T"
													)[0]
												}
											</Typography>
										</Grid>
										<Grid item xs={4} align="right">
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
											>
												ORA MEV:{" "}
												{
													newReceipt?.soap_response?.datetime?.split(
														"T"
													)[1]
												}
											</Typography>
										</Grid>
									</Grid>
								)}

								{newReceipt && (
									<Grid container spacing={2} align="left">
										<Grid item xs={8}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
											>
												MEV ID:
											</Typography>
										</Grid>
										<Grid item xs={4} align="right">
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
											>
												{newReceipt?.soap_response
														?.id ||
													newReceipt?.soap_data?.id ||
													"N/A"}
											</Typography>
										</Grid>
									</Grid>
								)}

								<Grid container spacing={2} align="left">
									<Grid item xs={8}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											NUMARUL DE INREGISTRARE:
										</Typography>
									</Grid>
									<Grid item xs={4} align="right">
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											{card.number}
										</Typography>
									</Grid>
								</Grid>

								<Grid container spacing={2} align="left">
									<Grid item xs={8}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											SN:
										</Typography>
									</Grid>
									<Grid item xs={4} align="right">
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											{card.factory}
										</Typography>
									</Grid>
								</Grid>

								<Divider/>
								<Grid container spacing={2} align="center">
									<Grid item xs={12}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											*** BON DE SERVICIU ***
										</Typography>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
				<Snackbar
					open={openSuccess}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="success"
						sx={{width: "100%"}}
					>
						{t("receipt_created_msg")}
					</Alert>
				</Snackbar>
			</Box>
		</>
	);
}

function CurrentDate() {
	let today = new Date();
	let day = today.getDate().toString().padStart(2, "0");
	let month = (today.getMonth() + 1).toString().padStart(2, "0");
	let currentDate = day + "." + month + "." + today.getFullYear();
	return <>{currentDate}</>;
}

function CurrentTime() {
	let today = new Date();
	let hours = today.getHours().toString().padStart(2, "0");
	let minutes = today.getMinutes().toString().padStart(2, "0");
	let seconds = today.getSeconds().toString().padStart(2, "0");
	let time = hours + ":" + minutes + ":" + seconds;
	return <>{time}</>;
}
